<template>
  <div class="shipping-po">
    <CustomTitle :title="mytitle"/>
    <div class="table-header df-c" :style="{
      fontSize: fontsize + 'px',
      lineHeight: (fontsize * 1.25) + 'px'   
    }">
      <span class="index">#</span>
      <span v-for="(item, index) in tableHeader" :key="index" 
            :style="{flex: item=='客户PO'||item=='模号'?'1.7':'1'}">
        {{ item }}
      </span>
    </div>
    <div class="scroll-chart">
      <vue-seamless-scroll :data="tableData" class="warp" :class-option="classOption">
        <template v-for="(item, index) in tableData">
          <div class="table-item df-c" :key="index" ref="TableItem" :style="{
            fontSize: fontsize + 'px',
            lineHeight: (fontsize * 1.25) + 'px'
          }">
            <span class="index">{{index+1}}</span>
            <span class="overflow-text" style="flex:1.7">{{item.PartNu?item.PartNu.slice(-safePnlen):item.PartNu}}</span>
            <span class="overflow-text">{{item.CurDEP}}</span>
          </div>
        </template>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import CustomTitle from '@/components/CustomTitle'
import vueSeamlessScroll from 'vue-seamless-scroll'
import { speak } from '@/utils/speech';
import config from '@/js/config'
import moment from 'moment'

export default {
  name: 'Shippingpo',
  data() {
    return {
      compid: -1,
      dept: '',
      mytitle: "今日出货表",
      tableHeader: ['工号', '部门'],
      tableData: [],
      classOption: { step: 0.5 },
      requestTimer: null,
      isShowPo: '',
      isShowMo: '',
      nowDay: moment().format('YYYY-MM-DD'),
      afterThreeDay: moment().add(2, 'days').format('YYYY-MM-DD'),
      requestUrl: '',
      retryTimer: null,
      fontsize: 16,
      speakstr: "",
      pnlen:11,
      emptyDataRefreshInterval: 60 * 1000, // 空数据时1分钟刷新
      normalRefreshInterval: 15 * 60 * 1000 // 正常时15分钟刷新
    }
  },
  computed: {
  safePnlen() {
    return Math.abs(parseInt(this.pnlen)) || 11; // 强制转为正整数，默认 11
  }
},
  methods: {
    getPOparts() {
      clearTimeout(this.retryTimer);
      this.compid = window.localStorage.getItem('bsmcompid');
      this.dept = window.localStorage.getItem('bsmdept');
      this.isShowPo = window.localStorage.getItem('isShowPo');
      this.isShowMo = window.localStorage.getItem('isShowMo');
      
      const ttp = window.localStorage.getItem('bsmisbrushpcs');
      if (ttp > 0) this.classOption.step = ttp;

      const fnt = window.localStorage.getItem('bsmisfontsize');
      if (fnt > 10) this.fontsize = fnt;

      this.axios({
        method: 'post',
        url: `${this.requestUrl}/admin.php/Bigsreen/SalePartPMDDateFun?datekind=0&status=-1&compid=${this.compid}&dst=&ded=`
      })
      .then((Response) => {
        const data = JSON.parse(Response.data);
        
        // 处理表头显示
        if (this.isShowPo === '2' || !this.isShowPo) {
          this.tableHeader = this.tableHeader.filter(item => item !== '客户PO');
        }
        if (this.isShowMo === '2' || !this.isShowMo) {
          this.tableHeader = this.tableHeader.filter(item => item !== '模号');
        }
        // console.log("SalePartPMDDateFun")
        // console.log(data)
        this.tableData = data['rows'];
        this.speakstr = data["speek"];
        
        // 根据数据是否为空调整刷新频率
        this.adjustRefreshInterval(this.tableData.length === 0);
        this.playSpeech();
        // if (this.speakstr) {
        //   speak("今日需出货工号 " + this.speakstr);
        // }
      })
      .catch((error) => {
        // console.error("请求失败:", error);
        this.retryTimer = setTimeout(() => {
          this.getPOparts();
        }, config.retryTime);
      });
    },

    playSpeech() {
        if (this.speakstr) {
            // 添加延迟确保DOM加载完成
            setTimeout(() => {
                speak("今日需出货工号 " + this.speakstr);
            }, 1000);
            
            // Android特殊处理
            if (this.isAndroid()) {
                this.$nextTick(() => {
                    const event = new Event('click');
                    document.dispatchEvent(event);
                });
            }
        }
    },
    
    isAndroid() {
        return navigator.userAgent.toLowerCase().indexOf('android') > -1;
    },

    adjustRefreshInterval(isEmpty) {
      clearInterval(this.requestTimer);
      const interval = isEmpty 
        ? this.emptyDataRefreshInterval 
        : this.normalRefreshInterval;
      
      this.requestTimer = setInterval(() => {
        this.getPOparts();
      }, interval);
    },

    echoTime(time) {
      if (!time) return '';
      const timeArr = time.split('-');
      return timeArr.length >= 3 ? `${timeArr[1]}-${timeArr[2]}` : time;
    },

    echoColor(time) {
      if (!time) return '#fff';
      if (time < this.nowDay) return '#FFA8B6';
      if (time <= this.afterThreeDay) return '#FBCF5B';
      return '#fff';
    }
  },
  created() {
    this.requestUrl = window.localStorage.getItem('requestUrl');
    this.pnlen = Number(window.localStorage.getItem('bsmpnlen')) || 11;
    this.getPOparts();
  },
  mounted() {
    // 初始化设置刷新频率
    this.adjustRefreshInterval(this.tableData.length === 0);
    
    // 语音播报定时器（每10分钟一次）
    this.speektTimer = setInterval(() => {      
      if (this.speakstr) {       
        speak("今日需出货工号 " + this.speakstr);
      }
    }, 10 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.requestTimer);
    clearInterval(this.speektTimer);
    clearTimeout(this.retryTimer);
  },
  components: {
    CustomTitle,
    vueSeamlessScroll
  }
}
</script>

<style scoped lang="less">
.shipping-po {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px 8px !important;
  
  .table-header {
    margin-top: 8px;
    background: linear-gradient(0deg, #1b6787 -24.83%, #4aaef7 100%);
    padding: 0 16px;
    border-radius: 8px 8px 0px 0px;
    
    .index {
      width: 30px;
      flex: unset;
    }
    
    span {
      flex: 1;
      padding: 7px 2px;
      text-align: center;
      font-family: 'PingFang SC';
      font-weight: 500;
      color: #ffffff;
      
      &:nth-child(2) {
        flex: 1.7 !important;
      }
    }
  }
  
  .table-item {
    cursor: pointer;
    padding: 0 16px;
    
    .index {
      width: 30px;
      flex: unset;
    }
    
    span {
      flex: 1;
      padding: 5px 2px;
      text-align: center; 
      font-family: 'PingFang SC';
      font-weight: 500;
      color: #bae3e6;
      
      &:nth-child(2) {
        flex: 1.7 !important;
      }
    }
  }

  .scroll-chart {
    flex: 1;
    min-height: 100px;
    overflow: hidden;
    border: 1px solid #2dcdff;
    border-top: 0;
    border-radius: 0px 0px 8px 8px;
    
    .warp {
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/bigscreenSales/components/ShippingShipParts.vue